import { Controller } from '@hotwired/stimulus'
import { patch } from '@rails/request.js'

export default class extends Controller<HTMLDivElement> {
  static targets = ['spinner', 'input']
  static values = {
    action: String,
    name: String
  }

  declare readonly spinnerTarget: HTMLDivElement
  declare readonly inputTarget: HTMLInputElement

  declare readonly actionValue: string
  declare readonly nameValue: string

  connect(): void {
    console.log(this, this.nameValue, this.actionValue)
  }

  toggle(): void {
    this.spinnerTarget.classList.remove('hidden')

    patch(this.actionValue, {
      body: JSON.stringify({
        [this.nameValue]: this.inputTarget.value
      }),
      responseKind: 'turbo-stream'
    }).finally(() => {
      this.spinnerTarget.classList.add('hidden')
    })
  }
}
